'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

import Logo from '@/components/bazak-logo';
import { smoothScrollToY } from '@/components/smooth-hash-scroll';
import { cn, FOCUS_RING_TEXT } from '@/lib/utils';

export function LogoLink({
  className,
  logoClassName,
  onNavigate,
}: {
  className?: string;
  logoClassName?: string;
  onNavigate?: () => void;
}) {
  const pathname = usePathname();

  return (
    <Link
      href="/"
      // The label names what the click does, which differs by page.
      aria-label={pathname === '/' ? 'Bazak — back to top' : 'Bazak — home'}
      className={cn('flex items-center', FOCUS_RING_TEXT, className)}
      onClick={event => {
        onNavigate?.();
        // Already home: scroll rather than client-navigate, on the same curve the section links
        // use. `behavior: 'smooth'` is a fixed browser easing and read as a different control
        // next to them.
        if (pathname !== '/') return;
        event.preventDefault();
        smoothScrollToY(0);
        // replace, not push: at `/` this is a scroll, not a navigation, and pushing stacked one
        // history entry per click so Back had to be pressed as many times as the logo was.
        history.replaceState(null, '', '/');
      }}
    >
      <Logo className={cn('h-7 w-auto', logoClassName)} />
    </Link>
  );
}
